import React from "react";
import { useHasPermission } from "@/hooks/usePermissions";
import { Loader } from "./Loader";

interface PermissionGateProps {
  permission:
    | string
    | string[]
    | { anyOf?: string[]; allOf?: string[]; not?: string[] };
  fallback?: React.ReactNode;
  children: React.ReactNode;
  showLoading?: boolean;
}

/**
 * Component for conditional rendering based on permissions
 * Only renders children if user has the specified permission
 */
export function PermissionGate({
  permission,
  fallback = null,
  children,
  showLoading = false,
}: PermissionGateProps) {
  const { allowed, isLoading } = useHasPermission(permission);

  if (isLoading && showLoading) {
    return <Loader />;
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
}
